module.exports = __webpack_public_path__ + "img/debtPayingAbility5.f158c427.png";